<template>
  <footer
    v-if="
      $store.state.main.mallType ||
        $route.params.path1 == 'about-us' ||
        $route.params.path1 == 'card-loyal'
    "
  >
    <div class="footer__subscribe container flex al-center between">
      <div class="socials">
        <div class="title light uppercase font-13">
          {{ socialChannels.title }}
        </div>
        <div class="socials-list flex al-center">
          <a
            :href="_.get(channel, 'url')"
            target="_blank"
            class="item flex al-center pointer"
            v-for="(channel, index) in socialChannels.list"
            :key="'a' + index"
            v-html="_.get(channel, 'svg')"
          ></a>
        </div>
      </div>
      <div class="subscribe">
        <div class="title light uppercase font-13">
          {{ $fn.tr('მიიღეთ სიახლე და უახლესი შემოთავაზებები!') }}
        </div>
        <div class="subscribe-input">
          <el-form
            @submit.prevent.native="
              '';


            "
            :model="contactData"
            :rules="rules"
            ref="contact"
          >
            <el-form-item prop="email">
              <el-input
                class="default-input-style"
                :placeholder="$fn.tr('მიუთითეთ ელ ფოსტა')"
                v-model="contactData.email"
              ></el-input>
            </el-form-item>
          </el-form>

          <div class="email-exist" v-if="emailExist">
            {{ $fn.tr('Email already exists!') }}
          </div>
          <div class="arrow" @click="sendData">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
              <g id="Group_6623" data-name="Group 6623" transform="translate(0 0)">
                <rect
                  id="Rectangle_453"
                  data-name="Rectangle 453"
                  width="40"
                  height="40"
                  transform="translate(0 0)"
                  fill="#1a1a1a"
                />
                <path
                  id="Path_1081"
                  data-name="Path 1081"
                  d="M9.091,5.241l5.66,5.661h0L10.9,14.751h0L5.241,9.091v5.66H0V0H14.751V5.242Z"
                  transform="translate(30.431 20.001) rotate(135)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
        </div>
        <div v-if="showSuccessMessage" class="subscribe-success">
          {{ $fn.tr('მეილი წარმატებით გაიგზავნა!') }}
        </div>
      </div>
      <div class="apps">
        <div class="title light uppercase font-13">
          {{ _.get($store.state.main.indx, 'widgets.app.title') }}
        </div>

        <div class="app-svgs flex al-center">
          <a
            :href="_.get($store.state.main.indx, 'widgets.app.appstore.url')"
            target="_blank"
            class="item pointer"
            v-html="_.get($store.state.main.indx, 'widgets.app.appstore.svg')"
          >
          </a>
          <a
            :href="_.get($store.state.main.indx, 'widgets.app.playstore.url')"
            target="_blank"
            class="item pointer"
            v-html="_.get($store.state.main.indx, 'widgets.app.playstore.svg')"
          >
          </a>
        </div>
      </div>
    </div>
    <div class="footer__menu container">
      <div class="menu-item" v-for="(item, index) in footer.footerMenu" :key="'b' + index">
        <div class="title bold uppercase">{{ item.title }}</div>
        <template v-for="(child, index2) in item.children">
          <router-link
            v-if="!_.get(child, 'shortlink')"
            tag="div"
            :to="child.full_url"
            class="child uppercase pointer"
            :key="'c' + index2"
          >
            {{ child.title }}
          </router-link>
          <a
            v-else
            :href="child.full_url"
            target="_blank"
            class="child uppercase pointer"
            :key="index2"
          >
            {{ child.title }}
          </a>
        </template>
      </div>
      <div class="dropdown-menus">
        <div
          class="menu-item-dropdown uppercase bold flex column pointer"
          v-for="(item, indx) in footer.shopMenu"
          :key="'d' + indx"
          @click="toggleMenu(item.id)"
          :class="{ open: selectedId == item.id }"
        >
          <div class="menu-item-title uppercase bold flex al-center pointer">
            {{ item.title }}
            <svg
              v-if="item.children"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>

          <slide-up-down :active="selectedId == item.id" :duration="600" class="dropdown-list">
            <MenuChildren :menuId="item.id" />
            <router-link
              tag="div"
              :to="child.full_url"
              class="dropdown"
              v-for="child in item.children"
              :key="child.id"
              v-html="child.title"
            ></router-link>
          </slide-up-down>
        </div>
        <div
          class="menu-item-dropdown uppercase bold flex column pointer"
          v-for="(item, ind) in footer.allFilterMenus"
          :key="'e' + ind"
          @click="toggleMenu(item.id)"
          :class="{ open: selectedId == item.id }"
        >
          <div
            v-if="_.size(item.children)"
            class="menu-item-title uppercase bold flex al-center pointer"
          >
            {{ item.title }}
            <svg
              v-if="item.children"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>
          <router-link
            v-else
            tag="div"
            :to="item.full_url"
            class="menu-item-title uppercase bold flex al-center pointer"
          >
            {{ item.title }}
            <svg
              v-if="item.children"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </router-link>
          <slide-up-down :active="selectedId == item.id" :duration="600" class="dropdown-list">
            <router-link
              tag="div"
              :to="child.full_url"
              class="dropdown"
              v-for="child in item.children"
              :key="child.id"
              v-html="child.title"
            >
              <!-- {{ child.title }} -->
            </router-link>
          </slide-up-down>
        </div>
      </div>
      <div class="contact-menu">
        <div>
          <div class="menu-item-title uppercase bold">
            {{ contactInfo.title }}
          </div>
          <div class="contact-menu-list">
            <template v-for="(info, indx) in contactInfo.data">
              <div
                :key="'i' + indx"
                v-if="info.content"
                class="contact-menu__row bold uppercase text"
                v-html="info.content"
              ></div>
            </template>
          </div>
        </div>

        <router-link
          v-if="$route.params.path1 !== 'about-us' && $route.params.path1 !== 'card-loyal'"
          tag="div"
          :to="mallUrl"
          class="location uppercase bold"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.505"
            height="16"
            viewBox="0 0 15.505 16"
          >
            <path
              id="Path_3184"
              data-name="Path 3184"
              d="M78.062,85.233v3.242h4.764l-4.4,4.545,2.371,2.447L85.2,90.922v4.916h3.142V85.233Zm0-5.395v3.243H90.425V95.838h2.268a.889.889,0,0,0,.875-.9V80.665a.815.815,0,0,0-.8-.827Z"
              transform="translate(-78.062 -79.838)"
              fill="#4d4d4f"
            />
          </svg>

          {{
            $route.params.path1 == 'saburtalo'
              ? $fn.tr('სითი მოლი გლდანი')
              : $fn.tr('სითი მოლი საბურთალო')
          }}
        </router-link>
        <div class="relative choose-mall" v-else>
          <div
            @click="openMallDropdown = !openMallDropdown"
            class="label bold uppercase pointer"
            :class="{ open: openMallDropdown }"
          >
            {{ $fn.tr('აირჩიეთ მოლი') }}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>
          <slide-up-down :active="openMallDropdown" :duration="600" class="dropdown">
            <router-link
              tag="div"
              :to="`/${this.$store.state.main.locale}/saburtalo`"
              class="location uppercase bold"
            >
              {{ $fn.tr('სითი მოლი საბურთალო') }}
            </router-link>
            <router-link
              tag="div"
              :to="`/${this.$store.state.main.locale}/gldani`"
              class="location uppercase bold"
            >
              {{ $fn.tr('სითი მოლი გლდანი') }}
            </router-link>
          </slide-up-down>
        </div>
      </div>
    </div>
    <div class="footer__running-logo">
      <marquee-text :duration="30">
        <svg-components class="long-logo" name="long-logo-footer" />
      </marquee-text>
    </div>
    <div class="footer__bottom container">
      <div class="copyright flex al-center uppercase bold">
        <svg-components name="copyright" />
        {{ $fn.tr('copyright all rights reserved') }}
      </div>
      <!-- <a
        href="https://www.connect.ge/en/"
        target="_blank"
        class="credits pointer"
      >
        <svg-components name="connect" />
      </a> -->
    </div>
  </footer>
</template>

<script>
import SvgComponents from '../SvgComponents.vue';
import Main from '../../mixins/main';
import fn from '../../helpers/func';
import MenuChildren from './MenuChildren.vue';

export default {
  components: { SvgComponents, MenuChildren },
  mixins: [Main],

  data() {
    const _this = this;
    return {
      selectedId: null,
      emailExist: false,
      showSuccessMessage: false,
      openMallDropdown: false,
      rules: {
        email: [
          {
            required: true,
            message: _this.$fn.tr('Please type email address'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: _this.$fn.tr('Please type the correct email address'),
            trigger: ['blur', 'change'],
          },
        ],
      },
      contactData: {
        email: '',
      },
    };
  },
  computed: {
    footer() {
      const mallType = this.$store.state.main.mallType || 'saburtalo';
      const menu = this.makeMenuTree('footer');
      const allMenu = this.makeMenuTree();
      const filteredMenu = allMenu.find(
        (menu) => _.get(menu, 'url') == mallType && !menu.configs.includes('hide-from-menu')
      )?.children;

      const allFilterMenus = filteredMenu?.filter(
        (item) =>
          item.configs.includes('menu-footer') &&
          !item.configs.includes('hide-from-menu') &&
          !item.configs.includes('has_children')
      );
      let footerMenu = menu.filter((item) => !item.configs.includes('hide-from-menu'));

      if (this.$route.params.path1 == 'about-us' || this.$route.params.path1 == 'card-loyal') {
        footerMenu = footerMenu.filter((item) => item.url == 'saburtalo' || item.url == 'about-us');
      } else if (this.$route.params.path1 == 'saburtalo') {
        footerMenu = footerMenu.filter(
          (item) =>
            item.url == 'visitor-saburtalo' ||
            item.url == 'other-saburtalo' ||
            item.url == 'about-us'
        );
      } else {
        footerMenu = footerMenu.filter(
          (item) =>
            item.url == 'visitor-gldani' || item.url == 'other-gldani' || item.url == 'about-us'
        );
      }

      const shopMenu = filteredMenu?.filter(
        (menu) => menu.configs.includes('menu-footer') && menu.configs.includes('has_children')
      );
      return { footerMenu, allFilterMenus, shopMenu };
    },
    socialChannels() {
      const data = this.$store.state.main.indx?.widgets?.social_channels;
      const result = {
        title: data.title,
        list: [],
      };
      Object.values(data).forEach((obj) => {
        if (typeof obj !== 'string') result.list.push(obj);
      });

      return result;
    },
    contactInfo() {
      const data = this.$store.state.main.indx.widgets;
      const mallType = this.$store.state.main.mallType || 'saburtalo';
      return {
        title: data[`footer_contact_${mallType}`]?.title,
        data: [
          {
            title: 'address',
            content: data[`footer_contact_${mallType}`]?.address,
          },
          {
            title: 'mail',
            content: data[`footer_contact_${mallType}`]?.mail,
          },
          {
            title: 'phone',
            content: data[`footer_contact_${mallType}`]?.phone,
          },
          {
            title: 'working-hours',
            content: data[`footer_contact_${mallType}`]['working-hours'],
          },
        ],
      };
    },
    mallUrl() {
      return this.$route.params.path1 == 'saburtalo'
        ? `/${this.$store.state.main.locale}/gldani`
        : `/${this.$store.state.main.locale}/saburtalo`;
    },
  },
  methods: {
    toggleMenu(id) {
      if (this.selectedId == id) {
        this.selectedId = null;
        return;
      }
      this.selectedId = id;
    },
    sendData() {
      let formData = {};
      formData.email = this.contactData.email;
      formData.formType = 'subscribe';
      this.$refs['contact']?.validate((valid) => {
        if (valid) {
          fn.postData('main/subscribe', formData).then((response) => {
            if (response.status == 200) {
              this.contactData.email = '';
              this.showSuccessMessage = true;
              this.emailExist = false;
              setTimeout(() => {
                this.showSuccessMessage = false;
              }, 6000);
            } else if (response.status == 201) {
              this.emailExist = true;
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.dropdown-menus {
  sup {
    // font-family: "Hm-Pangram-black";
    font-size: 10px;
  }
}
</style>
<style lang="scss">
@keyframes infiniteLogo {
  0% {
    -webkit-transform: translateX(0px);
  }
  100% {
    -webkit-transform: translateX(-50%);
  }
}
footer {
  padding-top: 55px;
  background: $white;
  .subscribe {
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__error {
        top: 45px;
      }
    }
    .subscribe-success {
      color: $green;
      margin-top: 5px;
    }
  }

  .footer {
    &__running-logo {
      padding: 34px 0;
      border-top: 2px solid #f7f7f7;
      border-bottom: 2px solid #f7f7f7;

      .long-logo {
        svg {
          margin-right: 15px;
        }
        z-index: 99;
        // animation: infiniteLogo 25s linear infinite;
      }
    }
    &__bottom {
      display: flex;
      justify-content: space-between;
      padding-top: 24px;
      padding-bottom: 24px;

      .copyright {
        svg {
          margin-right: 10px;
        }
      }
    }
    &__subscribe {
      border-bottom: 2px solid #f7f7f7;
      padding-bottom: 55px;
      @media (max-width: 1023px) {
        display: flex;
        flex-wrap: wrap;
        border-bottom: unset;
        padding-bottom: 0;

        .subscribe {
          order: 3;
          width: 100%;
          padding-top: 34px;
          margin-top: 34px;
          border-top: 2px solid #f7f7f7;
          .subscribe-input {
            width: 100% !important;
          }
        }
      }
      @media (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
        .apps {
          margin-top: 34px;
          padding-top: 34px;
          width: 100%;
          border-top: 2px solid #f7f7f7;
        }
        .subscribe {
          padding-top: 0px;
          border-top: unset;
        }
      }
      .socials-list {
        margin-top: 28px;

        .item {
          margin-right: 10px;
        }
      }
      .subscribe {
        .subscribe-input {
          position: relative;
          margin-top: 20px;
          width: fit-content;
          .email-exist {
            font-size: 12px;
            color: $red;
          }
          input {
            background: #f7f7f7;
            border: 1px solid rgba(181, 181, 181, 0.1);
            width: 700px;
            height: 40px;
            padding: 0 20px;
            @media (max-width: 1499px) {
              width: 420px;
            }
            @media (max-width: 1365px) {
              width: 325px;
            }
            @media (max-width: 1023px) {
              width: 100%;
            }

            &::placeholder {
              color: rgba(77, 77, 79, 0.3);
              text-transform: uppercase;
              -webkit-font-feature-settings: 'case';
              font-feature-settings: 'case' on;
            }
          }
          .arrow {
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }
      .apps {
        .app-svgs {
          margin-top: 20px;

          .item {
            margin-right: 10px;
          }
        }
      }
    }

    &__menu {
      display: grid;
      grid-template-columns: repeat(5, minmax(0px, auto));
      grid-gap: 30px;
      margin-bottom: 60px;
      padding-top: 89px;
      @media (max-width: 1359px) {
        grid-template-columns: repeat(4, minmax(0px, auto));
      }
      @media (max-width: 1023px) {
        grid-template-columns: repeat(2, minmax(0px, auto));
        grid-gap: 34px;
      }
      @media (max-width: 767px) {
        grid-template-columns: repeat(1, minmax(0px, auto));
        margin-bottom: 55px;
        padding-top: 55px;
      }
      .menu-item {
        .title {
          margin-bottom: 15px;
        }
        .child {
          transition: 0.2s ease-in-out;
          display: block;
          color: $black;
          &:hover {
            color: $red;
          }
          @media (max-width: 767px) {
            &:not(:last-child) {
              margin-bottom: 11px;
            }
          }
        }
      }
      .menu-item-dropdown {
        margin-bottom: 10px;
        .dropdown-list {
          .dropdown {
            transition: 0.2s ease;
            &:hover {
              color: $red;
            }
          }
        }

        &.open {
          // max-height: 50px;
          // overflow: hidden;
          .menu-item-title {
            color: $red;
            svg {
              path {
                fill: $red;
              }
            }
          }
          svg {
            transform: rotate(180deg);
            path {
              transition: 0.2s ease;
            }
          }
        }
      }
      .menu-item-title {
        color: #4d4d4f;
        transition: 0.2s ease;

        svg {
          transition: 0.2s ease;

          margin-left: 5px;
        }
      }
      .contact-menu {
        .contact-menu-list {
          border-bottom: 1px solid #f7f7f7;
          padding-bottom: 20px;
          margin-bottom: 20px;
          @media (max-width: 1359px) and (min-width: 1023px) {
            // width: 55vw;
            // display: flex;
            // flex-wrap: wrap;
            .contact-menu__row {
              &:nth-child(odd) {
                width: 320px;
              }
            }
          }
        }
        .location {
          cursor: pointer;
          svg {
            margin-right: 10px;
            transition: 0.2s ease;
            will-change: transform;
          }
          &:hover {
            svg {
              transform: rotate(45deg);
            }
          }
        }
        .cards {
          cursor: pointer;
          @media (max-width: 767px) {
            margin-right: 0px;
          }
          .label {
            @media (max-width: 767px) {
              display: none;
            }
            margin: 0 10px;
          }
          .flex {
            @media (max-width: 767px) {
              margin-right: 5px;
            }
          }
        }
        .choose-mall {
          cursor: pointer;
          .label {
            svg {
              transition: 0.4s ease;
            }

            &.open {
              svg {
                transform: rotate(180deg);
              }
            }
          }
          .dropdown {
            .location {
              display: flex;
              justify-content: flex-start;
              transition: 0.2s ease-in-out;
              &:hover {
                color: $red;
              }
            }
            position: absolute;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            min-width: 250px;
            left: 0;
            top: 19px;
          }
        }
        .menu-item-title {
          margin-bottom: 20px;
        }
        &__row {
          display: flex;
          margin-bottom: 5px;

          .label {
            color: #3c3c3e;
            margin-right: 2px;
          }
        }
      }
    }
  }
  .text-bold * {
    // font-family: "Hm-Pangram-bold";
    font-family: 'Firago-Book';
  }
}
</style>
